import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["likes"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { UnavailableInLens } from '@infl-ts/ui-advocate-components';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, Button, Typography } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { absurd, constNull, pipe } from 'fp-ts/function';
import { useTranslation } from 'react-i18next';
import LikesList from './likes-list';
import { useLikesInfo } from './queries';
import { useLikeUnlike } from './use-like-unlike';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getTargetType = function getTargetType(typename) {
  if (typename === 'PublicResponse') return 'ChallengeResponse';
  if (typename === 'PublicResponseComment') return 'ChallengeResponseComment';
  return absurd(typename);
};

var LikeButton = function LikeButton(_ref) {
  var targetID = _ref.targetID,
      typename = _ref.typename,
      userLike = _ref.userLike,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx;

  var _useLikeUnlike = useLikeUnlike({
    likeTarget: {
      targetID: targetID,
      targetType: getTargetType(typename)
    },
    typename: typename,
    userLike: userLike
  }),
      toggleLike = _useLikeUnlike.toggleLike,
      isLoading = _useLikeUnlike.isLoading;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(UnavailableInLens, {
    tooltip: true,
    "data-element": "UnavailableInLens",
    "data-component": "LikeButton",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Button, {
      sx: mergeSxProps({
        minWidth: 'auto',
        px: 1,
        color: function color(t) {
          return userLike ? t.palette.primary.main : t.palette.text.secondary;
        }
      }, sx),
      disabled: isLoading,
      onClick: toggleLike,
      "data-element": "Button",
      "data-component": "LikeButton",
      "data-source-file": "index.tsx",
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "buttonSmall",
        sx: {
          fontWeight: function fontWeight(t) {
            return t.typography.fontWeightBold;
          }
        },
        "data-element": "Typography",
        "data-component": "LikeButton",
        "data-source-file": "index.tsx",
        children: t('Like')
      })
    })
  });
};

var Likes = function Likes(_ref2) {
  var likeTargetId = _ref2.likeTargetId,
      _ref2$hideLikeButton = _ref2.hideLikeButton,
      hideLikeButton = _ref2$hideLikeButton === void 0 ? false : _ref2$hideLikeButton,
      likeButtonSx = _ref2.likeButtonSx;
  return pipe(useLikesInfo({
    variables: {
      id: likeTargetId
    }
  }), DE.map(function (_ref3) {
    var _ref3$node = _ref3.node,
        likes = _ref3$node.likes,
        node = _objectWithoutProperties(_ref3$node, _excluded);

    return _objectSpread(_objectSpread({}, node), {}, {
      likes: likes !== null && likes !== void 0 ? likes : {
        totalCount: 0
      }
    });
  }), DE.squash(constNull, constNull, function (_ref4) {
    var __typename = _ref4.__typename,
        currentUserLike = _ref4.currentUserLike,
        likes = _ref4.likes;
    return /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex'
      },
      children: [!hideLikeButton && /*#__PURE__*/_jsx(LikeButton, {
        targetID: likeTargetId,
        typename: __typename,
        userLike: currentUserLike,
        sx: likeButtonSx
      }), likes.totalCount > 0 && /*#__PURE__*/_jsx(LikesList, {
        entityId: likeTargetId,
        totalCount: likes.totalCount
      })]
    });
  }));
};

export default Likes;